import { axiosInstance, BASE_URLS } from "@/src/shared/api";
import { ProcessInstanceType } from "@/src/shared/schemas";
import { CreateRatingType } from "@/src/shared/schemas/rating";

export const createRating = async (
  payload: CreateRatingType,
): Promise<ProcessInstanceType> => {
  const response = await axiosInstance.post(`${BASE_URLS.RATING}`, payload);
  return response.data;
};

export const updateRating = async ({
  id,
  payload,
}: {
  id: string;
  payload: CreateRatingType;
}): Promise<ProcessInstanceType> => {
  const response = await axiosInstance.post(
    `${BASE_URLS.RATING}${id}`,
    payload,
  );
  return response.data;
};
